import tagApi from '../../../services/plataforma/tags';

export default {
  getAll(_, { page, perPage, search }) {
    return tagApi.getAll({ page, perPage, search })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  }
};
